import React, { FunctionComponent } from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import { t, Trans } from '@lingui/macro'

import HeadTitle from '../../components/common/head/HeadTitle'

import { CreateUsersImport } from './create-users-import/CreateUsersImport'
import { UsersImportDetails } from './users-import-details/UsersImportDetails'

import './BulkUsersImportPage.less'
import PageHeader from '../../components/common/page/header/PageHeader'
import { Page } from '../../components/common/page/Page'

export const BulkUsersImportPage: FunctionComponent = () => {
  const { url } = useRouteMatch()

  return (
    <Page className="BulkUsersImportPage">
      <HeadTitle title={t`Bulk import user details`} />
      <PageHeader className="PageHeader" title={t`Bulk import user details`}>
        <div className="PageHeader__subtitle">
          <Trans>
            Create new users or add and update user details from a data file
          </Trans>
        </div>
      </PageHeader>
      <div className="BulkUsersImportPage__Content">
        <div className="BulkUsersImportPage__Inner">
          <Switch>
            <Route path={`${url}/:importId`} component={UsersImportDetails} />
            <Route exact path={`${url}/`} component={CreateUsersImport} />
          </Switch>
        </div>
      </div>
    </Page>
  )
}
